import accountInfo from './state/account-info';
import { getFromLocalStorage } from './utils';
import { logWithAmplitude } from './api/api';
import organizationInfo from './state/organization-info';
import subscriptionInfo from './state/subscription-info';
import topicData from './state/topic-data';

export function openChatWindow(amplitude_callsite: string, Message?: string) {
        logWithAmplitude(amplitude_callsite, 'Open Chat Click');
        let script = document.createElement('script');
        if (accountInfo.isAuthenticated) {
            script.innerHTML = `window.intercomSettings = {
                api_base: "https://api-iam.intercom.io/",
                app_id: "o343lm6n",
                name: "${accountInfo.fullName !== '' ? accountInfo.fullName : accountInfo.email}", // Full name
                email: "${accountInfo.email ?? getFromLocalStorage('email') ?? topicData.email}", // Email address
              };`;
        } else {
            script.innerHTML = `window.intercomSettings = {
                api_base: "https://api-iam.intercom.io/",
                app_id: "o343lm6n",
              };`;
        }

        document.body.appendChild(script);

        script = document.createElement('script');
        script.innerHTML = `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/o343lm6n';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`;
        document.body.appendChild(script);
        if (Message) {
            (window as any).Intercom('showNewMessage', Message);
        } else {
            (window as any).Intercom('show');
        }
}

export function logAsLead(amplitude_callsite: string, email: string) {
    logWithAmplitude(amplitude_callsite, 'Generate Lead');
    let script = document.createElement('script');
    if (accountInfo.isAuthenticated) {
        script.innerHTML = `window.intercomSettings = {
                api_base: "https://api-iam.intercom.io/",
                app_id: "o343lm6n",
                name: "${
                    accountInfo.fullName !== '' ? accountInfo.fullName : accountInfo.email
                }", // Full name
                email: "${email}" // Email address
              };`;
    } else {
        script.innerHTML = `window.intercomSettings = {
                api_base: "https://api-iam.intercom.io/",
                app_id: "o343lm6n",
                email: "${email}"
              };`;
    }

    document.body.appendChild(script);

    script = document.createElement('script');
    script.innerHTML = `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/o343lm6n';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`;
    document.body.appendChild(script);
    (window as any).Intercom('boot');
}

export function setIntercomUserDetails() {
    if (accountInfo.isAuthenticated) {
        const updateData: any = {
            'name': accountInfo.fullName !== '' ? accountInfo.fullName : accountInfo.email,
            'Subscribed': subscriptionInfo.isActive ? 'true' : 'false',
            'In trial': subscriptionInfo.isTrial ? 'true' : 'false'
        };

        // Add company object if organization ID exists
        if (organizationInfo.id?.$oid) {
            updateData.company = {
                id: organizationInfo.id.$oid,
                name: organizationInfo.organization?.name ?? 'Unknown Organization',
                plan: subscriptionInfo.subscription_plan_id ?? undefined,
                monthly_spend: subscriptionInfo.subscription?.mrr_total ?? undefined,
                'Organization Id': organizationInfo.id?.$oid ?? '',
                'Add Ons': subscriptionInfo.subscription?.add_ons?.map(addOn => addOn).join(', ') ?? undefined
            };
        }

        (window as any).Intercom('update', updateData);
    }
}

// write a function to check if it is working hours in pacific time. Working hours are 9AM-4:30PM Pacific Time Monday to Friday
export function isWorkingHours() {
    const date = new Date();
    const day = date.getDay();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const time = hour + minute / 60;
    if (day === 0 || day === 6) {
        return false;
    }
    if (time < 9 || time > 16.5) {
        return false;
    }
    return true;
}
